var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.dataSources),function(dataSource){return _c('details-datasource',{key:dataSource,attrs:{"instance":_vm.instance,"data-source":dataSource}})}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5fd4ef6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/views/instances/details/details-datasources.vue
// module id = null
// module chunks = 